export default __webpack_public_path__ + "static/media/PhoneNoInnerCircle.13672d39.png";